import { createFileRoute } from '@tanstack/react-router'
import { EstoquePageContent } from '@/features/estoque/estoque-page'

export const Route = createFileRoute('/_authenticated/estoque')({
  component: EstoquePageContent,
})
